import { RouterProvider } from 'react-router';
import routeConfig from '../../configs/route/route.config';

export default function NavigationApp() {
  return <RouterProvider router={routeConfig} />;
}
